import { UserCardTokensFragment } from 'src/graphql/generated/graphql'
import { getUserCardTokens } from 'src/react_query'

export const awaitForTokens = async (
  tokenTypes: (keyof UserCardTokensFragment)[],
) => {
  const timeout = 60_000
  const delayBetweenCalls = 4_000

  const deadline = Date.now() + timeout
  while (true) {
    if (Date.now() > deadline) {
      throw new Error('did not get tokens until timeout')
    }

    await new Promise(resolve => setTimeout(resolve, delayBetweenCalls))

    // We're bypassing react query here, but I think it does make things a lot simpler for now.
    const cardTokens = await getUserCardTokens()
    // Note that this works for both integer and boolean properties
    for (const tokenType of tokenTypes) {
      if (cardTokens[tokenType]) {
        return
      }
    }
  }
}
